document.addEventListener('DOMContentLoaded', function() {
    const searchInputs = document.querySelectorAll('.country-search__input');
    const countryList = document.querySelector('.CountryList');
    const disclosureButton = document.querySelector('.disclosure__button');
    
    searchInputs.forEach(searchInput => {
      const countrySelector = searchInput.closest('popover-content, .disclosure, .popover-container');
      const countryList = countrySelector && countrySelector.querySelector('.CountryList, .popover__choice-list');
      const countryItems = countryList ? Array.from(countryList.querySelectorAll('.disclosure__item, .popover__choice-item')) : [];
      const priorityGroups = countryList ? Array.from(countryList.querySelectorAll('.disclosure__priority-countries')) : [];
      const originalPlacement = countryItems.map(item => ({
        item: item,
        parent: item.parentNode
      }));

      if (!countryList || countryItems.length === 0) {
        return;
      }

      let searchTimeout;
      
      searchInput.addEventListener('keydown', function(e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          return false;
        }
      });
      
      searchInput.addEventListener('input', function() {
        clearTimeout(searchTimeout);
        searchTimeout = setTimeout(() => {
          const searchTerm = this.value.toLowerCase().trim();
          
          const matchingCountries = [];
          const nonMatchingCountries = [];

          countryItems.forEach(item => {
            const countryText = item.textContent.toLowerCase();

            item.hidden = false;

            if (searchTerm !== '' && countryText.includes(searchTerm)) {
              matchingCountries.push(item);
            } else {
              nonMatchingCountries.push(item);
            }
          });

          priorityGroups.forEach(group => group.hidden = true);

          if (searchTerm === '') {
            priorityGroups.forEach(group => group.hidden = false);
            originalPlacement.forEach(placement => placement.parent.appendChild(placement.item));
            return;
          }

          matchingCountries.forEach(item => countryList.appendChild(item));
          nonMatchingCountries.forEach(item => countryList.appendChild(item));
        }, 150);
      });
    });
    
    if (disclosureButton) {
      document.addEventListener('click', function(e) {
        const disclosure = disclosureButton.closest('.disclosure');
        const isClickInside = disclosure && disclosure.contains(e.target);
        
        if (!isClickInside && countryList && !countryList.hidden) {
          countryList.hidden = true;
          disclosureButton.setAttribute('aria-expanded', 'false');
        }
      });
    }
});
